import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";
import Collapse from "./Collapse";

const CGRFComplainDetailsView = ({
  applicationData,
  isExpandable = true,
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Category of Grievance",
        key: "grievanceCategories",
        isRequired: true,
        renderField: (value) =>
          value ? value.map(({ name }) => name).join(", ") : "-",
      },
      {
        name: "Name of Employee/Employees",
        key: "employeeName",
        isRequired: true,
      },

      {
        name: "Details of the complaint",
        key: "complaintDetails",
        isRequired: true,
      },
      {
        name: "Nature of relief sought from forum",
        key: "reliefNature",
        isRequired: true,
      },
    ],
    []
  );

  return (
    <>
      <Collapse title={"Complain Details"} isExpandable={isExpandable}>
        <Row className="d-flex  mb-2">
          {fields.map(({ name, key, isRequired, renderField }) => {
            const value = get(applicationData, key, "");
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(applicationData, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Collapse>
    </>
  );
};

CGRFComplainDetailsView.propTypes = {
  applicationData: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(CGRFComplainDetailsView);
